import * as React from 'react';
import { Button, Form, Col, Row } from 'antd';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as uuid from 'uuid';

import { DataTableView, ToolbarVisibility, Column } from 'src/core/ui/data-table.view';
import { TextView } from 'src/core/ui/text.view';
import { CurrencyEditorView } from 'src/app/general/currencies/parts/currency-editor.view';

interface GroupedRates {
	displayName: string;
	fromCurrency: number;
	toCurrency: number;
	fromCurrencyRate?: number;
	toCurrencyRate?: number;
}

const defaultCurrencyCreator = function (item: GroupedRates, self: CurrencyDefaultRateListView, startEditing?: boolean) {
	this.uuid = uuid.v4();
	this.displayName = item.displayName;
	this.fromCurrencyRate = item.fromCurrencyRate;
	this.toCurrencyRate = item.toCurrencyRate;
	this.fromCurrency = item.fromCurrency;
	this.toCurrency = item.toCurrency;
	this.currency = item;
	this.isEditing = false;

	this.edit = function () {
		const currentEdit = self.currencies ? self.currencies.find(e => e.isEditing == true) : null;
		if (currentEdit) {

			currentEdit.isEditing = false;
		}
		if (this != currentEdit) {
			this.isEditing = true;
		}
		self.forceUpdate();
	};

	if (startEditing) {
		this.edit();
	}

}

@observer
export class CurrencyDefaultRateListView extends React.Component<CurrencyDefaultRateListViewProps, any> {
	@observable
	newDefaultCurrency: CurrencySummary;

	oldDefaultCurrency: CurrencySummary;

	constructor(props: any) {
		super(props);
	}
	currencies: any[] = [];
	render() {
		if (this.props.defaultCurrency == null) return null;
		const currencies = this.props.currencies != null ? this.props.currencies.slice() : null;
		let constr: any[] = [];
		let gruop = this.groupByCurrencies(this.props.model.items);
		gruop.map((item) => {
			let d = this.currencies.find(x => x.currency.displayName == item.displayName);
			if (d == null) {
				this.currencies.push(new defaultCurrencyCreator(item, this, false));
				d = this.currencies[this.currencies.length - 1];
			}
			else {
				d.displayName = item.displayName;
				d.fromCurrencyRate = item.fromCurrencyRate;
				d.toCurrencyRate = item.toCurrencyRate;
				d.fromCurrency = item.fromCurrency;
				d.toCurrency = item.toCurrency;
				d.currency = item;
			}
			constr.push(<tr key={d.uuid} onDoubleClick={d.isEditing ? null : d.edit.bind(d)}>
				<td className='cell' style={{ width: 20 }}>
					<Button icon={d.isEditing ? 'close' : 'edit'} onClick={d.edit.bind(d)} />
				</td>
				<td style={{ width: 100 }} className={d.isEditing ? 'cell' : ''}>
					{
						d.displayName
					}
				</td>
				<td style={{ width: 100 }} className={d.isEditing ? 'cell' : ''}>
					{
						!d.isEditing ? d.fromCurrencyRate : <TextView mode='edit' label={null}
							value={d.fromCurrencyRate}
							onChanged={newVal => {
								d.fromCurrencyRate = newVal;
								this.setCurrencyRateProp(d.currency, 'fromCurrencyRate', newVal)

							}} />
					}
				</td>
				<td style={{ width: 100 }} className={d.isEditing ? 'cell' : ''}>
					{
						!d.isEditing ? d.toCurrencyRate : <TextView mode='edit' label={null}
							value={d.toCurrencyRate}
							onChanged={newVal => {
								d.toCurrencyRate = newVal;
								this.setCurrencyRateProp(d.currency, 'toCurrencyRate', newVal)

							}} />
					}
				</td>
			</tr>);
		})

		return <div className="card card-borderless">
			<h2>
				{this.props.title}
			</h2>
			<table className="b-table" key="dailyTable">
				<thead>
					<tr>
						<th style={{ width: 85 }} ></th>
						<th style={{ width: 100 }}>Currency</th>
						<th style={{ width: 100 }}>From ${this.props.defaultCurrency.iso3Name}</th>
						<th style={{ width: 100 }}>To ${this.props.defaultCurrency.iso3Name}</th>
					</tr>
				</thead>
				<tbody>
					{
						constr
					}
				</tbody>
			</table>
			<Row gutter={16}>
				<Col xs={24} sm={16}>
					<CurrencyEditorView
						required
						mode="edit"
						onChange={(item) => {
							this.newDefaultCurrency = item
						}}
						label='Default currency'
						value={this.props.defaultCurrency.id}
						currencies={currencies}
						currencyArrayObjectType={true}
					/>
				</Col>
				<Col xs={24} sm={8}>
					<Form.Item label='&nbsp;'
						colon={false}>
						<Button type="primary" onClick={this.changeDefaultCurrency} style={{ width: '100%' }} disabled={this.props.defaultCurrency == this.newDefaultCurrency || this.newDefaultCurrency == null} >Change</Button>
					</Form.Item>
				</Col>
			</Row >
		</div >;
	}

	@autobind
	private changeDefaultCurrency() {
		if (this.oldDefaultCurrency == null) {
			this.oldDefaultCurrency = this.props.defaultCurrency;
		}
		this.props.changeDefaultCurrency(this.newDefaultCurrency);
	}

	@autobind
	private groupByCurrencies(items: CurrencyDefaultRateItem[]): GroupedRates[] {
		const rows: GroupedRates[] = [];
		for (const rate of items) {
			const fromCurrency = this.props.currencies.find(c => c.id == rate.fromCurrencyId);
			const toCurrency = this.props.currencies.find(c => c.id == rate.toCurrencyId);
			const isFrom = fromCurrency.id == this.props.defaultCurrency.id;
			let obj: GroupedRates = rows.find(e => e.displayName == (isFrom ? toCurrency : fromCurrency).iso3Name);
			if (obj == null) {
				obj = {
					displayName: (isFrom ? toCurrency : fromCurrency).iso3Name,
					fromCurrency: isFrom ? rate.id : null,
					toCurrency: isFrom ? null : rate.id,
					fromCurrencyRate: isFrom ? rate.rate : null,
					toCurrencyRate: isFrom ? null : rate.rate,
				};
				rows.push(obj);
			}
			if (isFrom && obj.fromCurrency == null) {
				obj.fromCurrency = rate.id;
				obj.fromCurrencyRate = rate.rate;
			} else if (obj.toCurrency == null && !isFrom) {
				obj.toCurrency = rate.id;
				obj.toCurrencyRate = rate.rate;
			}
		}
		if (this.oldDefaultCurrency) {
			for (let item of rows) {
				if (item.fromCurrency == null) {
					const currency = this.props.currencies.find(e => e.iso3Name == item.displayName);
					const rate = items.find(e => e.toCurrencyId == currency.id && e.fromCurrencyId == this.oldDefaultCurrency.id);
					item.fromCurrency = rate.id;
					item.fromCurrencyRate = rate.rate;
				}
			}
		}
		return rows;
	}
	@autobind
	private setCurrencyRateProp(item: GroupedRates, field: string, value: any) {
		if (field == 'fromCurrencyRate') {
			const i = this.props.model.items.find(e => e.id == item.fromCurrency);
			i.rate = value;
		} else {
			const i = this.props.model.items.find(e => e.id == item.toCurrency);
			i.rate = value;
		}
	}
}





// WEBPACK FOOTER //
// ./src/app/products/currency-default-rates/list/currency-default-rate-list.view.tsx